export const getCampaignList = 'https://interview.interworksmedia.co.kr/api/interview/?cmd=campaign.list&uid='
export const getCampainDetail = 'https://interview.interworksmedia.co.kr/api/interview/?cmd=campaign.data'
export const getDashboard = 'https://interview.interworksmedia.co.kr/api/interview/?cmd=dashboard&uid='
export const loginRequest = 'https://interview.interworksmedia.co.kr/api/interview/'
export const getNoticeList = 'https://interview.interworksmedia.co.kr/api/interview/?cmd=notice&uid='
export const getPromotions = 'https://interview.interworksmedia.co.kr/api/interview/?cmd=promotion&uid='
// export const insertGangnam = 'https://interview.interworksmedia.co.kr/api/interview/'



// WEBPACK FOOTER //
// ./src/api/url.js